import { Purpose } from "config/constants"
import { useEffect, useMemo } from "react"
import { useTenantSettings } from "stores/tenantSettings"

interface IUseReservationCommissionDisplayParams {
    purpose?: Purpose
    commission?: string | number | null
    isCommissionActive?: boolean
}

export default function useReservationCommissionDisplay({
    purpose,
    commission,
    isCommissionActive,
}: IUseReservationCommissionDisplayParams) {
    const {
        commissions,
        fetchCommissions,
    } = useTenantSettings()

    useEffect(() => {
        if (commissions) return
        fetchCommissions()
    }, [commissions, fetchCommissions])

    const isCommissionDisplayed = useMemo(() => {
        if (!purpose) return false
        return isCommissionActive
            || (commission !== null && commission !== '' && typeof commission !== "undefined")
            || (purpose === Purpose.sale && typeof commissions?.commissionSales === "number")
            || (purpose === Purpose.rent && typeof commissions?.commissionRental === "number")
    }, [commission, commissions, purpose, isCommissionActive])

    return {
        isCommissionDisplayed,
        commissions,
    }
}
